import { render } from "./imgBox.vue?vue&type=template&id=407943fe&scoped=true"
import script from "./imgBox.vue?vue&type=script&lang=js"
export * from "./imgBox.vue?vue&type=script&lang=js"

import "./imgBox.vue?vue&type=style&index=0&id=407943fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-407943fe"

export default script